import {API_ROOT_URL} from 'envs/_current/config'
import _ from 'lodash'
import {normalize, schema} from 'normalizr'
import {compose} from 'redux'
import {channelSchema, groupSchema, organizationSchema, userSchema} from './schema'
import {eventSchema} from './schema/event'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

const fixStpProperty = (entity) => {
    const {status, role_id} = entity
    const statusMap = createStpProperty(memberFieldTypes.status, status)
    const roleMap = createStpProperty(memberFieldTypes.role_id, role_id)
    return {
        ...entity,
        ...statusMap,
        ...roleMap,
    }
}

export const memberFieldTypes = {
    status: [
        {
            value: -9,
            label: 'rejected',
        },
        {
            value: -8,
            label: 'kicked',
        },
        {
            value: -7,
            label: 'banned',
        },
        {
            value: -2,
            label: 'invited',
        },
        {
            value: -1,
            label: 'registered',
        },
        {
            value: 0,
            label: 'removed',
        },
        {
            value: 1,
            label: 'active',
        },
    ],
    role_id: [
        {
            value: 1,
            label: 'owner',
            description: 'owner_description',
        },
        {
            value: 2,
            label: 'admin',
            description: 'admin_description',
        },
        {
            value: 3,
            label: 'member',
            description: 'member_description',
        },
    ],
}
export const memberStatusTypes = {
    '-9': {
        value: -9,
        label: 'rejected',
    },
    '-8': {
        value: -8,
        label: 'kicked',
    },
    '-7': {
        value: -7,
        label: 'banned',
    },
    '-2': {
        value: -2,
        label: 'invited to become member',
    },
    '-1': {
        value: -1,
        label: 'sent a request to become member',
    },
    0: {
        value: 0,
        label: 'removed',
    },
    1: {
        value: 1,
        label: 'active',
    },
}

export const memberSchema = new schema.Entity(
    'members',
    {
        user: userSchema,
    },
    {
        idAttribute: 'id',
        processStrategy: compose(fixStpProperty),
    }
)
const createStpProperty = (options, value) =>
    options.reduce((result, option) => {
        result[`is${_.capitalize(option.label)}`] = '' + value === '' + option.value
        return result
    }, {})

// Member
export const member_getById_Api = {
    backend: `Route::get('members/{prop}/{id}/member/{m_id}/get', 'MemberController@getById');`,
    root: API_ROOT_URL,
    path: '/members/:type/:id/member/:m_id/get',
    method: 'GET',
    schema: memberSchema,
    transform: createTransform(memberSchema, 'data'),
}


export const member_setRole_Api = {
    backend: `// Route::post('members/{prop}/{id}/member/{m_id}/set-role', 'MemberController@setRole');`,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:m_id/set-role',
    method: 'POST',
    schema: memberSchema,
    fields: ['role_id'],
    fieldTypes: {
        role_id: memberFieldTypes.role_id,
    },
    transform: createTransform(memberSchema, 'data'),
}

export const member_kick_Api = {
    backend: `// Route::post('members/{prop}/{id}/member/{m_id}/kick', 'MemberController@manageMemberKick');`,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:m_id/kick',
    method: 'POST',
    schema: memberSchema,
    fields: [],
    fieldTypes: {},
    transform: createTransform(memberSchema, 'data'),
}

export const member_remove_Api = {
    backend: `Route::post('members/{prop}/{id}/member/{m_id}/delete', 'MemberController@manageMemberRemove');`,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:m_id/delete',
    method: 'POST',
    schema: memberSchema,
    fields: [],
    fieldTypes: {},
    transform: createTransform(memberSchema, 'data'),
}


export const member_ban_Api = {
    backend: `Route::post('members/{prop}/{id}/member/{m_id}/ban', 'MemberController@manageMemberBan')`,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:m_id/ban',
    method: 'POST',
    transform: createTransform(memberSchema, 'data'),
}

export const member_unBan_Api = {
    backend: `Route::post('members/{prop}/{id}/member/{m_id}/remove-banned', 'MemberController@manageMemberRemoveBan');`,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:m_id/remove-banned',
    method: 'POST',
    transform: createTransform(memberSchema, 'data'),
}

export const member_getContactMembers_Api = {
    backend: `Route::get('members/{prop}/{id}/get-contact-members', 'MemberController@getContactMembers');`,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/get-contact-members',
    method: 'GET',
    schema: memberSchema,
    fields: [],
    fieldTypes: {},
    transform: createListTransform(memberSchema),
}

export const member_getMembers_Api = {
    backend: ``,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/gets',
    method: 'GET',
    schema: memberSchema,
    fields: [],
    paramsFields: ['status', 'role_id', 'visible', 'keyword', 'group_id'],
    fieldTypes: {},
    transform: createListTransform(memberSchema),
}

export const member_joinAsMember_Api = {
    backend: ``,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/user/join',
    method: 'POST',
    fields: [],
    fieldTypes: {},
    transform: createTransform(
        new schema.Entity(
            'members',
            {
                user: userSchema,
                owner: new schema.Union(
                    {
                        event: eventSchema,
                        channel: channelSchema,
                        organization: organizationSchema,
                        group: groupSchema,
                    },
                    '_type'
                ),
            },
            {
                idAttribute: 'id',
            }
        ),
        'data'
    ),
}

export const member_leaveAsMember_Api = {
    backend: ``,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/user/leave',
    method: 'POST',
    fields: [],
    fieldTypes: {},
    transform: createTransform(
        new schema.Union(
            {
                event: eventSchema,
                channel: channelSchema,
                organization: organizationSchema,
                group: groupSchema,
            },
            '_type'
        ),
        'data'
    ),
}



export const member_userAcceptAsMember_Api = {
    backend: `Route::post('members/{type}/{id}/user/accept-as-member', 'MemberController@acceptAsMember');`,
    root: API_ROOT_URL,
    path: '/members/:type/:id/user/accept-as-member',
    method: 'POST',
    fields: [],
    fieldTypes: {},
    transform: createTransform(
        new schema.Union(
            {
                event: eventSchema,
                channel: channelSchema,
                organization: organizationSchema,
                group: groupSchema,
            },
            '_type'
        ),
        'data'
    ),
}

export const member_userRejectAsMember_Api = {
    backend: `Route::post('members/{type}/{id}/user/reject-as-member', 'MemberController@rejectAsMember');`,
    root: API_ROOT_URL,
    path: '/members/:type/:id/user/reject-as-member',
    method: 'POST',
    fields: [],
    fieldTypes: {},
    transform: createTransform(
        new schema.Union(
            {
                event: eventSchema,
                channel: channelSchema,
                organization: organizationSchema,
                group: groupSchema,
            },
            '_type'
        ),
        'data'
    ),
}

export const member_getRequestedUsers_Api = {
    name: 'member_getRequestedUsers',
    backend:
        "Route::get('members/{prop}/{id}/get-requested-users', 'MemberController@getRequestedUsers')",
    root: API_ROOT_URL,
    path: '/members/:prop/:id/get-requested-users',
    method: 'GET',
}

export const member_manageMemberAccept_Api = {
    name: 'member_manageMemberAccept',
    backend: "Route::post('members/{prop}/{id}/member/{m_id}/accept', 'MemberController@manageMemberApprove');",
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:m_id/accept',
    method: 'POST',
}

export const member_manageMemberReject = {
    name: 'member_manageMemberReject',
    backend: "Route::post('members/{prop}/{id}/member/{m_id}/reject', 'MemberController@manageMemberDeny');",
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:m_id/reject',
    method: 'POST',
}

export const member_switchOwner_Api = {
    name: 'member_switchOwner',
    backend: "Route::post('members/{prop}/{id}/member/{m_id}/set-as-owner', 'MemberController@setRoleAsOwner')",
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:m_id/set-as-owner',
    method: 'POST',
    transform: createTransform(channelSchema, 'data'),
}

export const member_assignRole_Api = {
    name: 'member_assignRole',
    backend:
        "Route::post('entity-roles/assign-role/{prop}/{id}/{role_id}/{m_id}/assign', 'EntityRoleController@assignRoleToMember')",
    root: API_ROOT_URL,
    path: '/entity-roles/assign-role/:prop/:id/:role_id/:m_id/assign',
    method: 'POST',
    transform: createTransform(memberSchema, 'data'),
}

export const member_removeRoleFromMember_Api = {
    name: 'member_removeRoleFromMember',
    backend:
        "Route::post('entity-roles/assign-role/{prop}/{id}/{role_id}/{m_id}/remove', 'EntityRoleController@removeRoleFromMember')",
    root: API_ROOT_URL,
    path: '/entity-roles/assign-role/:prop/:id/:role_id/:m_id/remove',
    method: 'POST',
    transform: (response, {query}) => {
        const {entities, result} = normalize(
            response.data,
            new schema.Entity(
                'members',
                {
                    user: userSchema,
                    owner: channelSchema,
                },
                {
                    idAttribute: 'id',
                    processStrategy: (entity) => {
                        return {
                            ...entity,
                            _roles: {
                                [query[':role_id']]: false,
                            },
                        }
                    },
                }
            )
        )
        return {
            entities,
            result,
        }
    },
}


export const member_searchUsersForMember_Api = {
    name: 'member_searchUsersForMember',
    backend: `Route::get('members/{prop}/{id}/user/search-non-member', 'MemberController@searchUsersForMember');`,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/user/search-non-member',
    method: 'GET',
    paramsFields: ['keyword'],
}

export const members_manageMemberAdd_Api = {
    name: 'members_manageMemberAdd',
    backend: `Route::post('members/{prop}/{id}/member/{u_id}/add', 'MemberController@manageMemberAdd')`,
    root: API_ROOT_URL,
    path: '/members/:prop/:id/member/:u_id/add',
    method: 'POST',
    schema: memberSchema,
    transform: createTransform(memberSchema, 'data'),
}

export const member_manageMemberEdit_Api = {
    backend: `Route::post('members/{prop}/{id}/member/{m_id}/edit', 'MemberController@manageMemberEdit');`,
    root: API_ROOT_URL,
    path: '/members/:type/:id/member/:m_id/edit',
    method: 'POST',
    schema: memberSchema,
    transform: createTransform(memberSchema, 'data'),
}


export const lookup_lookupInfoByValue_Api = {
    name: 'lookup_lookupInfoByValue_Api',
    backend: `Route::get('lookup/matched-value/{search_type}/by/{input_type}/{input_value}/get', 'LookupController@lookupInfoByValue');`,
    root: API_ROOT_URL,
    path: '/lookup/matched-value/:search_type/by/:input_type/:input_value/get',
    method: 'GET',
    paramsFields: ['owner_type', 'owner_id'],
}

export const member_getPendingInvitations_Api = {
    name: 'member_getPendingInvitations_Api',
    backend: `Route::get('members/get-pending-invitations', 'MemberController@getPendingInvitations');`,
    root: API_ROOT_URL,
    path: '/members/get-pending-invitations',
    method: 'GET',
    paramsFields: [],
}
